<section class="detail-card">
  <h4>Profile{{ readOnly ? '' : ' (Editable)' }}</h4>
  <div class="detail-field">
    <label>Discord Alias</label>
    <span *ngIf="readOnly">{{ collector.discordAlias || '—' }}</span>
    <input
      *ngIf="!readOnly"
      type="text"
      class="form-control"
      [(ngModel)]="collector.discordAlias"
      [ngModelOptions]="{ standalone: true }"
      (ngModelChange)="emitChange()"
    />
  </div>
  <div class="detail-field">
    <label>Team</label>
    <span *ngIf="readOnly">{{ collector.team || '—' }}</span>
    <div *ngIf="!readOnly" class="editable-combobox">
      <input
        #teamInput
        #teamTrigger="matAutocompleteTrigger"
        type="text"
        class="form-control team-combobox-input"
        autocomplete="off"
        aria-label="Team"
        [matAutocomplete]="teamAutocomplete"
        [(ngModel)]="collector.team"
        [ngModelOptions]="{ standalone: true }"
        (focus)="showAllTeamOptions()"
        (click)="openTeamOptions(teamInput, teamTrigger)"
        (ngModelChange)="onTeamChanged($event)"
      />
      <button
        type="button"
        class="editable-combobox-toggle"
        tabindex="-1"
        aria-label="Show all teams"
        (mousedown)="$event.preventDefault()"
        (click)="openTeamOptions(teamInput, teamTrigger)"
      >
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
    </div>
  </div>
  <div class="detail-field">
    <label>Role</label>
    <span *ngIf="readOnly">{{ collector.role || '—' }}</span>
    <div *ngIf="!readOnly" class="editable-combobox">
      <input
        #roleInput
        #roleTrigger="matAutocompleteTrigger"
        type="text"
        class="form-control role-combobox-input"
        autocomplete="off"
        aria-label="Role"
        [matAutocomplete]="roleAutocomplete"
        [(ngModel)]="collector.role"
        [ngModelOptions]="{ standalone: true }"
        (focus)="showAllRoleOptions()"
        (click)="openRoleOptions(roleInput, roleTrigger)"
        (ngModelChange)="onRoleChanged($event)"
      />
      <button
        type="button"
        class="editable-combobox-toggle"
        tabindex="-1"
        aria-label="Show all roles"
        (mousedown)="$event.preventDefault()"
        (click)="openRoleOptions(roleInput, roleTrigger)"
      >
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
    </div>
  </div>
</section>

<mat-autocomplete #teamAutocomplete="matAutocomplete">
  <mat-option *ngFor="let option of filteredTeamOptions" [value]="option">
    {{ option }}
  </mat-option>
</mat-autocomplete>

<mat-autocomplete #roleAutocomplete="matAutocomplete">
  <mat-option *ngFor="let option of filteredRoleOptions" [value]="option">
    {{ option }}
  </mat-option>
</mat-autocomplete>
